module.exports = __webpack_public_path__ + "assets/footer-cow.dde0673a.svg";